import React, { useMemo } from "react";
import pkg from "@inrscr/coschool-ui-components";
import { taskTypes } from "../../../../utils/LearningPathUtils";
import { Box } from "@chakra-ui/react";
import { styles } from "./TutorSubjectStyles";

const topicFeatureKeys = [
  "DescriptiveQuestions",
  "Advanced",
  "Chapter-End Assessment",
  "Prerequisite",
];

const subTopicFeatureKeys = [
  "Assessment",
  "GuidedPractice",
  "Learn",
];

const topicButtons = [
  { key: "Guided Practice", value: taskTypes.guidedPractice },
  { key: "Assesment Practice", value: taskTypes.assessment },
  { key: "Prerequisite", value: taskTypes.learnPrerequisite },
];

const subTopicButtons = [
  { key: "Guided Practice", value: taskTypes.guidedPractice },
  { key: "Assesment Practice", value: taskTypes.assessment },
  { key: "Learn", value: taskTypes.learnSubTopic },
];

const getStyleIndex = (feature) => {
  if (!feature) return 8; 
  const { report, config, is_enabled } = feature;
  const binary = `${+!!report}${+!!config}${+!!is_enabled}`; 
  const index = parseInt(binary, 2) + 1; 
  return index;
};


const getFeatureKey = (isTopic, buttonKey) => {
  if (isTopic) {
    if (buttonKey === "Prerequisite") return "Prerequisite";
    if (["Guided Practice", "Assesment Practice"].includes(buttonKey)) {
      return "Chapter-End Assessment";
    }
  } else {
    if (buttonKey === "Guided Practice") return "GuidedPractice";
    if (buttonKey === "Assesment Practice") return "Assessment";
    if (buttonKey === "Learn") return "Learn";
  }
  return null;
};

const OtherActions = ({ isTopic, onClick, topicFeatures }) => {
  const { GlobalButtonV2 } = pkg;

  const topicFeaturesObject = useMemo(() => {
    return Object.keys(topicFeatures)
      .filter((key) => topicFeatureKeys.includes(key))
      .reduce((acc, key) => {
        acc[key] = topicFeatures[key];
        return acc;
      }, {});
  }, [topicFeatures]);

  const subTopicFeaturesObject = useMemo(() => {
    return Object.keys(topicFeatures)
      .filter((key) => subTopicFeatureKeys.includes(key))
      .reduce((acc, key) => {
        acc[key] = topicFeatures[key];
        return acc;
      }, {});
  }, [topicFeatures]);

  const updatedBtns = useMemo(() => {
    return isTopic ? topicButtons : subTopicButtons;
  }, [isTopic]);

  const activeFeatureObject = isTopic ? topicFeaturesObject : subTopicFeaturesObject;

  return (
    <Box {...styles?.otherActionsWrapper}>
      {updatedBtns?.map((item, index) => {
        const featureKey = getFeatureKey(isTopic, item.key);
        const featureData = activeFeatureObject[featureKey];
        const styleIndex = getStyleIndex(featureData);
        const buttonSx = styles[`buttonStyle${styleIndex}`];

        return (
          <GlobalButtonV2
            key={`item-${index}`}
            onClick={() => onClick(item?.value)}
            buttonText={item?.key}
            buttonType="Secondary"
            size="small"
            state="Enabled"
            buttonSx={buttonSx}
          />
        );
      })}
    </Box>
  );
};

export default OtherActions;
